module.exports = __webpack_public_path__ + "static/media/ka_background.5a0a690b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/backgrounds/ka_background.png
// module id = 2626
// module chunks = 0